import Nullstack from 'nullstack';
export default function IconLanguageOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-language-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 5h1m4 0h2"
  }), "   ", Nullstack.element("path", {
    d: "M9 3v2m-.508 3.517c-.814 2.655 -2.52 4.483 -4.492 4.483"
  }), "   ", Nullstack.element("path", {
    d: "M5 9c-.003 2.144 2.952 3.908 6.7 4"
  }), "   ", Nullstack.element("path", {
    d: "M12 20l2.463 -5.541m1.228 -2.764l.309 -.695l.8 1.8"
  }), "   ", Nullstack.element("path", {
    d: "M18 18h-5.1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}